import { render, staticRenderFns } from "./people_table.vue?vue&type=template&id=73ce7cb8&"
import script from "./people_table.vue?vue&type=script&lang=js&"
export * from "./people_table.vue?vue&type=script&lang=js&"
import style0 from "./people_table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73ce7cb8')) {
      api.createRecord('73ce7cb8', component.options)
    } else {
      api.reload('73ce7cb8', component.options)
    }
    module.hot.accept("./people_table.vue?vue&type=template&id=73ce7cb8&", function () {
      api.rerender('73ce7cb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/people/people_table.vue"
export default component.exports